<template>
  <h1>It is no secret...</h1>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      this.$emit("next");
    }, 2400);
  },
};
</script>
